module.exports = __webpack_public_path__ + "img/cornelius-van-drebel.4aa66cc9.png";